import { render, staticRenderFns } from "./BoxNotFound.vue?vue&type=template&id=09917cf4&"
import script from "./BoxNotFound.js?vue&type=script&lang=js&"
export * from "./BoxNotFound.js?vue&type=script&lang=js&"
import style0 from "./BoxNotFound.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports